<template>
  <div class="row">
    <div class="col-12" v-if="room.getAvailableBedsCount('double') > 0">{{ room.getAvailableBedsCount('double') }}&nbsp;
      {{ $t($vysklonujSlovo('manzelsk', room.getAvailableBedsCount('double'), 'e', 'ych', 'a')) }}&nbsp;
      {{ $t($vysklonujSlovo('postel', room.getAvailableBedsCount('double'), 'e', 'i')) }}
    </div>
    <div class="col-12" v-if="room.getAvailableBedsCount('single') > 0">{{ room.getAvailableBedsCount('single') }}&nbsp;
      {{ $t($vysklonujSlovo('jednolozkov', room.getAvailableBedsCount('single'), 'e', 'ych', 'a')) }}&nbsp;
      {{ $t($vysklonujSlovo('postel', room.getAvailableBedsCount('single'), 'e', 'i')) }}
    </div>
    <div class="col-12" v-if="room.getAvailableBedsCount('extraAdult') > 0">{{ room.getAvailableBedsCount('extraAdult') }}&nbsp;
      {{ $t($vysklonujSlovo('pristelka-pre-dospelych', room.getAvailableBedsCount('extra-bed-adult'), 'y', 'ok')) }}
    </div>
    <div class="col-12" v-if="room.getAvailableBedsCount('bunk') > 0">{{ room.getAvailableBedsCount('bunk') }}&nbsp;
      {{ $t($vysklonujSlovo('poschodova-postel', room.getAvailableBedsCount('bunk'), 'e', 'i')) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import AccommodationRoom from "../../../lib/models/AccommodationRoom";
import {useNuxtApp} from "#app";

const {$vysklonujSlovo} = useNuxtApp();
const props = defineProps({
  room: Object as PropType<AccommodationRoom>
})
</script>

